// ------
// Basic selectors
export const selectPackerPlants = state => {
  return state.qualityPackerPlants.data;
};
